<div class="modal-header">
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
    </button>
    <h4 class="modal-title">Groups</h4>
</div>

<div class="form-group modal-body" style="min-height: 400px;">
    <div class="container-fluid">

        <div class="row">
            <div class="col-md-12">
                <dx-data-grid biz-grid [selection]='{ mode: "none" }' [dataSource]='dataFieldGroups'
                    [bizSetGroupPanel]="false" [bizSetColumnChooser]="false" [bizSetAllowColumnReordering]="false"
                    [bizSetPager]="false" (onInitNewRow)="onInitNewRow($event)" (onRowInserted)="onRowInserted($event)"
                    (onRowUpdated)="onRowUpdated($event)" (onRowRemoving)="onRowRemoving($event)" style="max-height: 400px;" [bizEditRowOnDoubleClick]="true">

                    <dxo-editing mode="row" [allowUpdating]="allowUpdating" [allowAdding]="allowAdding"
                        [allowDeleting]="allowDeleting"></dxo-editing>

                    <dxo-group-panel [visible]="false"></dxo-group-panel>

                    <dxi-column dataField="DisplayName" caption="Display name" dataType="string" width="40%" sortOrder="asc">
                        <dxi-validation-rule type="required"></dxi-validation-rule>
                    </dxi-column>

                    <dxi-column dataField="Description" caption="Description" dataType="string" width="40%">
                    </dxi-column>

                    <dxi-column dataField="SortOrder" caption="Order" dataType="number" width="20%">
                        <dxi-validation-rule type="required"></dxi-validation-rule>
                    </dxi-column>
                </dx-data-grid>
            </div>
        </div>

    </div>
</div>

<div class="modal-footer">
    <div class="text-center">
        <button type="submit" style="min-width: 12rem;" class="btn btn-primary" (click)="ok()">Close</button>
    </div>
</div>
